import { FetchParams } from "../hooks/utility-hoks/useFetchWithToken";
import { User } from "../types/rokaTypes";

export type RokaApiErrorResponse = {
  errorMessage: string;
  errorType: string;
  requestId: string;
};

/**
 * GET USERS
 */
export type GetUsersResponse = {
  users: User[];
};
export const getUsersApi = (): FetchParams => {
  let url = "https://api.rmcounting.no/v3/admin/users";
  return { url };
};

/**
 * CREATE USER
 */
export type CreateUserRequestBody = {
  username: string;
  isAdmin: boolean;
  site: string;
  password: string;
};
export const createUserApi = (data: CreateUserRequestBody): FetchParams => {
  let url = "https://api.rmcounting.no/v3/admin/user";
  return { url, options: { method: "POST", body: JSON.stringify(data) } };
};

/**
 * UPDATE USER
 */
export type UpdateUserRequestBody = {
  isAdmin: boolean;
  isDisabled: boolean;
  site: string;
};
export const updateUserApi = (
  username: string,
  data: UpdateUserRequestBody,
): FetchParams => {
  let url = `https://api.rmcounting.no/v3/admin/user/${username}`;
  return { url, options: { method: "PUT", body: JSON.stringify(data) } };
};

/**
 * UPDATE USER PASSWORD
 */
export type UpdateUserPasswordRequestBody = {
  password: string;
};
export const updateUserPasswordApi = (
  username: string,
  data: UpdateUserPasswordRequestBody,
): FetchParams => {
  let url = `https://api.rmcounting.no/v3/admin/user/${username}/password`;
  return { url, options: { method: "PUT", body: JSON.stringify(data) } };
};

/**
 * GET SITES
 */
export type GetSitesResponse = {
  sites: [
    {
      name: string;
      eventDate: string; // timestamp (YYYY-MM-dd)
      maximum: number;
      updated: string | null; // timestamp (python's isoformat())
      sensors: [
        {
          name: string;
          current: number;
          updated: string | null; // timestamp (python's isoformat())
        },
      ];
    },
  ];
};
export const getSitesApi = (): FetchParams => {
  let url = "https://api.rmcounting.no/v3/admin/sites";
  return { url };
};

/**
 * GET SENSOR REFERENCE
 */
export type GetSensorReferenceResponse = {
  current_raw: number;
  current_raw_reference: number;
  current: number;
};
export const getSensorReferenceApi = (
  siteName: string,
  sensorName: string,
): FetchParams => ({
  url: `https://api.rmcounting.no/v3/admin/site/${siteName}/sensor/${sensorName}/reference`,
});

/**
 * UPDATE SENSOR REFERENCE
 */
export type UpdateSensorReferenceRequestBody = {
  reference?: number;
};
export const updateSensorReferenceApi = (
  siteName: string,
  sensorName: string,
  data: UpdateSensorReferenceRequestBody,
): FetchParams => ({
  url: `https://api.rmcounting.no/v3/admin/site/${siteName}/sensor/${sensorName}/reference`,
  options: { method: "PUT", body: JSON.stringify(data) },
});

/**
 * GET SITE STATE
 */
export const getSiteStateApi = (name: string): FetchParams => ({
  url: `https://api.rmcounting.no/v3/state?name=${encodeURIComponent(name)}`,
});

/**
 * SET SITE STATE
 */
export type SetSiteStateRequestBody = {
  name: string;
  reset_time: string;
};
export const setSiteStateApi = (
  data: SetSiteStateRequestBody,
): FetchParams => ({
  url: "https://api.rmcounting.no/v3/state",
  options: { method: "POST", body: JSON.stringify(data) },
});

/**
 * UPDATE SITE
 */
export type UpdateSiteRequestBody = {
  maximum: number;
};
export const updateSiteApi = (
  name: string,
  data: UpdateSiteRequestBody,
): FetchParams => {
  let url = `https://api.rmcounting.no/v3/admin/site/${name}`;
  return { url, options: { method: "PUT", body: JSON.stringify(data) } };
};
